namespace $.$$ {
	export class $shm_hitalama_components_version extends $.$shm_hitalama_components_version {
		title() { return 'Версия v' + this.entry().info()!.version }
		note() { return this.entry().info()!.note }
		details() {
			const info = this.entry().info()!
			return `Дата: ${ this.$.$shm_date.text( info.date.slice( 0, 10 ) ) }\nМодулей: ${ info.modules }\nАвтор: ${ info.author }`
		}
		commit_uri() {
			const info = this.entry().info()!
			if( !info.commit || !info.repository ) return ''
			return 'https://github.com/' + this.$.$shm_hitalama_components_github.repository( info.repository ) + '/commit/' + info.commit
		}
		commit_title() {
			const info = this.entry().info()!
			return info.commit ? 'GitHub · ' + info.commit.slice( 0, 12 ) : 'Старая версия без ссылки на коммит'
		}
	}
}
